import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import logo from "../../logo.png";

// Navbar container
const Navbar = styled.header`
    position: fixed;
    inset: 0 0 auto 0;
    height: 70px;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(61, 108, 77, 0.8);
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
`;

// Inner container
const NavInner = styled.nav`
    width: 100%;
    max-width: 1200px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

// Logo
const NavLogo = styled.img`
    height: 42px;
    width: auto;
    display: block;
`;

// Nav links container
const NavLinks = styled.ul`
    display: flex;
    gap: 18px;
    list-style: none;
    margin: 0;
    padding: 0;

    li a {
        font-weight: 600;
        color: #ffffea;
        padding: 8px 10px;
        border-radius: 8px;
        text-decoration: none;
    }

    li a:hover {
        background: #eef4ff;
        color: #ffffea;
    }

    /* Mobile styles */
    @media (max-width: 768px) {
        position: absolute;
        top: 70px;
        left: 0;
        right: 0;
        background: rgba(61, 108, 77, 0.95);
        flex-direction: column;
        align-items: center;
        gap: 10px;
        padding: 0;
        overflow: hidden;

        max-height: ${({ open }) => (open ? '500px' : '0')};
        transition: max-height 0.3s ease-in-out, padding 0.3s ease-in-out;
        padding: ${({ open }) => (open ? '15px 0' : '0')};
    }
`;

// Hamburger icon
const Hamburger = styled.div`
    display: none;
    cursor: pointer;
    flex-direction: column;
    gap: 5px;

    span {
        height: 3px;
        width: 25px;
        background: #ffffea;
        border-radius: 2px;
        transition: all 0.3s ease;
    }

    @media (max-width: 768px) {
        display: flex;
    }
`;

export default function NavbarSection() {
    const [menuOpen, setMenuOpen] = useState(false);
    const navRef = useRef(null);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navRef.current && !navRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <Navbar>
            <NavInner ref={navRef}>
                <a href="#home" aria-label="Начало">
                    <NavLogo src={logo} alt="EPDM Trading Bulgaria – лого"/>
                </a>

                <Hamburger onClick={() => setMenuOpen(!menuOpen)}>
                    <span style={{ transform: menuOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none' }}></span>
                    <span style={{ opacity: menuOpen ? 0 : 1 }}></span>
                    <span style={{ transform: menuOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none' }}></span>
                </Hamburger>

                <NavLinks open={menuOpen}>
                    <li><a href="#epdm" onClick={() => setMenuOpen(false)}>Защо EPDM</a></li>
                    <li><a href="#video" onClick={() => setMenuOpen(false)}>Видео</a></li>
                    <li><a href="#accessories" onClick={() => setMenuOpen(false)}>Аксесоари</a></li>
                    <li><a href="#comparison" onClick={() => setMenuOpen(false)}>Сравнение</a></li>
                    <li><a href="#contact" onClick={() => setMenuOpen(false)}>Контакти</a></li>
                </NavLinks>
            </NavInner>
        </Navbar>
    );
}
